import {ApiRes} from '../../types/api'
import {API_URL, apiPost, apiGet, apiDelete} from '../api'

export interface ICreateLeader {
    user_id: string
    tag: string
}

export const createPaytoSeeLeader = async (data: ICreateLeader) => {
    return await apiPost(API_URL, 'admin/pts_rec_leader', data)
}

export interface ProfitDetail {
    profit: number
    adjusted_profit: number
    earning: number
}

export interface ProfitSummary {
    [period: string]: ProfitDetail // e.g., "1", "30", "1000"
}

export interface ITraderProfile {
    user_id?: string
    thumbnail?: string
    name?: string
    win?: number
    loss?: number
    mdd?: number
    hold_avg?: number
    tf?: number
    profit_summary?: ProfitSummary
}

export const getPtsLeadersApi = async (): Promise<ApiRes<ITraderProfile[]>> => {
    return await apiGet(API_URL, `admin/pts_leaders`)
}

export const deletePTSLeaderApi = async (id: string) => {
    return await apiDelete(API_URL, `admin/pts_rec_leader/${id}?tag=pts`)
}
